import React, { useState } from "react";
import parentImg from "../../../../assets/images/parent.png";
import Pagination from "../../../../components/Pagination";

const TableView = ({
  // data
  parents,
  children,
  allChildren,
  isLoading,
  selectedParent,
  setSelectedParent,
  // search
  searchQuery,
  setSearchQuery,
  // status modal opener
  openStatusModal,
}) => {
  const ITEMS_PER_PAGE = 8;
  const SIDEBAR_PAGE_SIZE = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [sidebarPage, setSidebarPage] = useState(1);

  const handleSelectParent = (code) => {
    setSelectedParent(code);
    setCurrentPage(1);
    setSearchQuery("");
  };

  const sidebarTotalPages = Math.ceil(parents.length / SIDEBAR_PAGE_SIZE);
  const pagedParents = parents.slice(
    (sidebarPage - 1) * SIDEBAR_PAGE_SIZE,
    sidebarPage * SIDEBAR_PAGE_SIZE,
  );

  const filteredChildren = children.filter(
    (c) =>
      c.childName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      c.childCode.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const totalItems = filteredChildren.length;
  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
  const pagedChildren = filteredChildren.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE,
  );

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  if (isLoading) return <div className="pc-loading">Loading...</div>;

  return (
    <div className="pc-layout">
      {/* Sidebar */}
      <div className="pc-sidebar">
        <p className="pc-sidebar__label">COMPANIES</p>
        <div
          className={`pc-sidebar__item ${!selectedParent ? "active" : ""}`}
          onClick={() => handleSelectParent(null)}
        >
          <span>All</span>
          <span className="pc-sidebar__count">{allChildren.length}</span>
        </div>
        {pagedParents.map((p) => (
          <div
            key={p.parentCode}
            className={`pc-sidebar__item ${selectedParent === p.parentCode ? "active" : ""}`}
            onClick={() => handleSelectParent(p.parentCode)}
          >
            <span>{p.parentName}</span>
            <div className="pc-sidebar__item-right">
              <span className="pc-sidebar__count">
                {
                  allChildren.filter((c) => c.parentCode === p.parentCode)
                    .length
                }
              </span>
            </div>
          </div>
        ))}
        {sidebarTotalPages > 1 && (
          <div className="pc-sidebar__pagination">
            <button
              className="pc-sidebar__page-btn"
              disabled={sidebarPage === 1}
              onClick={() => setSidebarPage((p) => p - 1)}
            >
              ‹
            </button>
            <span className="pc-sidebar__page-info">
              {sidebarPage} / {sidebarTotalPages}
            </span>
            <button
              className="pc-sidebar__page-btn"
              disabled={sidebarPage === sidebarTotalPages}
              onClick={() => setSidebarPage((p) => p + 1)}
            >
              ›
            </button>
          </div>
        )}
      </div>

      {/* Main content */}
      <div className="pc-main">
        <div className="pc-main__topbar">
          <h2 className="pc-main__title">
            {selectedParent
              ? parents.find((p) => p.parentCode === selectedParent)
                  ?.parentName || "No Parents"
              : "All Distributors"}
          </h2>
          <div className="pc-main__topbar-right">
            <div className="pc-search">
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input
                className="pc-search__input"
                placeholder="Search by name, code..."
                value={searchQuery}
                onChange={handleSearch}
              />
              {searchQuery && (
                <button
                  className="pc-search__clear"
                  onClick={() => {
                    setSearchQuery("");
                    setCurrentPage(1);
                  }}
                >
                  ✕
                </button>
              )}
            </div>
          </div>
        </div>

        {totalItems === 0 ? (
          <div className="pc-empty text-center">
            <img className="parent-img" src={parentImg} />
          </div>
        ) : (
          <>
            <div className="pc-cards">
              {pagedChildren.map((c) => (
                <div
                  key={c.childCode}
                  className={`pc-card ${c.isActive ? "" : "pc-card--inactive"}`}
                >
                  <div className="pc-card__body">
                    <div>
                      <h3 className="pc-card__name">{c.childName}</h3>
                      <span className="pc-card__company">
                        {c.parentName || "No Parents"}
                      </span>
                    </div>
                    <div className="pc-card__right">
                      <span
                        className={`pc-card__status-badge ${
                          c.isActive
                            ? "pc-card__status-badge--active"
                            : "pc-card__status-badge--inactive"
                        }`}
                      >
                        {c.isActive ? "● Active" : "○ Inactive"}
                      </span>
                      <button
                        className="pc-btn pc-btn--status"
                        onClick={() => openStatusModal(c)}
                      >
                        Change Status
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="pc-pagination">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                onPageChange={setCurrentPage}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TableView;
